import React, { useState, useEffect, useContext } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Input from "./input";
import FontAwesome from "react-fontawesome";
import Renderlist from "./renderdetail";
import { savtruckover } from "../../services/wms";
import { toast } from "react-toastify";

const Modalconfirmbranch = ({
  isOpen,
  header,
  onCancel,
  onConfirm,
  message,
  list,
  onDisAprove,
  value,
  onChange,
  onProgress,
  error,
  size = "lg",
}) => {
  const [text, settext] = useState("");
  const [messageErros, setmessageErros] = useState({
    askAlert: { enable: false, message: "" },
  });
  return (
    <div>
      <Modal
        isOpen={isOpen}
        toggle={onCancel}
        size={size}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <ModalHeader>
          {list[0] && (
            <div className="row" style={{ fontSize: "16px" }}>
              <span
                style={{ fontSize: "16px" }}
                className="font-weight-normal badge bg-warning"
              >
                ยืนยันการชั่ง
              </span>
              {/* {"  "}
              <div className="ms-2">เลขใบชั่ง : {list[0].Receive_truckNo}</div>
              {"  "} */}
              {/* <div className="ms-2">ทะเบียน : {list[0].First_Driven_No}{" "}
                    {list[0].FirstProvinceCode}</div>
                    {"  "} */}
              {/* <div className="ms-2">ลูกค้า : {list[0].Customer_Name}{" "}
                    {list[0].FirstProvinceCode}</div> */}
            </div>
          )}
        </ModalHeader>
        <ModalBody>
          {list && list.length > 0 && (
            <div className="row mt-2">
              <div className="col-lg-4  col-sm-6 col-xs-12">
                <span
                  className="badge badge-pill badge"
                  style={{ fontSize: "14px" }}
                >
                  ทะเบียน :{" "}
                  {list[0].data[0].driven_no + ":" + list[0].data[0].DrivenProv}{" "}
                </span>
              </div>
            </div>
          )}
        </ModalBody>

        <ModalFooter>
          <Button
            color="primary"
            onClick={() => onConfirm([{ action: list[0] }])}
          >
            Save
          </Button>
          <Button color="secondary" onClick={onCancel}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Modalconfirmbranch;
